import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

/** Zeigt das aktuelle Datum mit Uhrzeit an und aktualisiert es jede Sekunde */
export default class TKClock extends TKCustomElementFactory {
    timer?: number;

    connectedCallback() {
        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.clearInterval(this.timer);
    }

    update() {
        this.textContent = new Date().toLocaleString('de-CH');
    }
}
